import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';

var Clickable = function (_a) {
    var children = _a.children, className = _a.className, tabIndex = _a.tabIndex, onClick = _a.onClick, isCursorPointer = _a.isCursorPointer, props = __rest(_a, ["children", "className", "tabIndex", "onClick", "isCursorPointer"]);
    var onKeyPress = useCallback(function (event) {
        if (onClick) {
            onClick(event);
        }
    }, [onClick]);
    return (jsx("span", __assign({ role: "button", tabIndex: tabIndex, onKeyPress: onKeyPress, onClick: onClick, className: className, style: { cursor: isCursorPointer ? "pointer" : "auto" } }, props, { children: children }), void 0));
};

export { Clickable as default };
